<div class="" fxLayout="column" fxLayoutAlign="start stretch">

  <ng-container *ngIf="data.formulario == 'paquete'">
    <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
      <mat-icon class="s-30 mr-20">filter_1</mat-icon>
      <div class="h3 secondary-text"><b>{{'PAQUETES.PREVIO.STEPS.1' | translate}}</b></div>
    </div>

    <div class="" fxLayout="row" fxLayoutAlign="space-around center">

      <div *ngFor="let boton of paquetes; let i = index;" class="mat-elevation-z4 p-20 roundEdg botonPaq"
        [ngClass]="{
          '': paqSel != (i+1),
          ' paqSelec': paqSel == (i+1)
        }"
        fxLayout="row" fxLayoutAlign="space-between center" (click)="seleccionaPaquete((i+1))">
        <button mat-mini-fab disabled [ngClass]="boton.clase" (click)="seleccionaPaquete((i+1))">
          <mat-icon>star</mat-icon>
        </button>
        <h2 class="ml-20 mt-0 mb-0">{{'PAQUETES.NOMBRES.'+(i+1) | translate}}</h2>
      </div>
    </div>

    <mat-divider class="mt-40"></mat-divider>

    <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
      <mat-icon class="s-30 mr-20">filter_2</mat-icon>
      <div class="h3 secondary-text"><b>{{'PAQUETES.PREVIO.STEPS.2' | translate}}</b></div>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-form-field *ngIf="years" fxFlex="30">
        <mat-label>{{'PAQUETES.INFOPAQ.CERTIFICAR.INFO.TABLA.2' | translate}}</mat-label>
        <mat-select [(value)]="anioSeleccionado">
          <mat-option *ngFor="let anio of years.anios" value="{{anio.anio}}">{{anio.anio}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-divider class="mt-40"></mat-divider>

    <div fxLayout="row" fxLayoutAlign="space-evenly center">
      <button mat-raised-button color="accent" class="mt-20" (click)="salir()">{{'PAQUETES.PREVIO.BOTONES.CANCELAR' | translate}}</button>
      <button mat-raised-button color="primary" class="mt-20" (click)="agregaPaquete()">{{'PAQUETES.PREVIO.BOTONES.ADDPACK' | translate}}</button>
    </div>
  </ng-container>

  <ng-container *ngIf="data.formulario == 'categoria' && !operacionInterna && !productoMultiple">

    <h2 class="mt-20">{{'PAQUETES.INFOPAQ.CERTIFICAR.TITULO.3' | translate}}</h2>

    <mat-divider class="mb-20"></mat-divider>

    <div class="" fxLayout="row wrap" fxLayoutAlign="center" fxLayoutGap="20px grid">

      <ng-container *ngIf="data.numProducto == 7 && normaConfig; else restoProds">
        <ng-container *ngFor="let producto of listaProductosElegidos">
          <div *ngIf="producto.configurado" class="" fxFlex="33" fxLayout="column" fxLayoutAlign="start stretch">
            <button mat-raised-button fxFlex="0 1 calc(33.3% - 32px)" fxLayout="column" fxLayoutAlign="start stretch" matTooltip="{{'PAQUETES.TOOLTIP.CONFIG' | translate}}" matTooltipPosition="above" (click)="opInterna(producto.idProducto,producto.configurado)">
              <div class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between center">
                <button mat-mini-fab disabled class="prodComp">
                  <mat-icon>check</mat-icon>
                </button>
                <h3 class="mb-0 ws">{{'CONSULTATABLA.PRODUCTOS.'+producto.idProducto | translate}}</h3>
                <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.TITULO' | translate}}{{'PAQUETES.INFOPAQ.STATUS.OK_2' | translate}}</em>
              </div>
            </button>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #restoProds>
        <div *ngFor="let producto of listaProductosElegidos" class="" fxFlex="33" fxLayout="column" fxLayoutAlign="start stretch">
          <button mat-raised-button fxFlex="0 1 calc(33.3% - 32px)" fxLayout="column" fxLayoutAlign="start stretch" matTooltip="{{'PAQUETES.TOOLTIP.CONFIG' | translate}}" matTooltipPosition="above" (click)="opInterna(producto.idProducto,producto.configurado)">
            <div class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between center">
              <ng-container *ngIf="!producto.configurado; else iconoCompleto">
                <button mat-mini-fab disabled>
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <h3 class="mb-0 ws">{{'CONSULTATABLA.PRODUCTOS.'+producto.idProducto | translate}}</h3>
                <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.TITULO' | translate}}{{'PAQUETES.INFOPAQ.STATUS.NOTOK_2' | translate}}</em>
              </ng-container>
              <ng-template #iconoCompleto>
                <button mat-mini-fab disabled class="prodComp">
                  <mat-icon>check</mat-icon>
                </button>
                <h3 class="mb-0 ws">{{'CONSULTATABLA.PRODUCTOS.'+producto.idProducto | translate}}</h3>
                <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.TITULO' | translate}}{{'PAQUETES.INFOPAQ.STATUS.OK_2' | translate}}</em>
              </ng-template>
            </div>
          </button>
        </div>
      </ng-template>

    </div>

    <mat-divider class="mt-20 mb-20"></mat-divider>

    <div fxLayout="row" fxLayoutAlign="space-evenly center">
      <button mat-raised-button color="accent" class="mt-20" (click)="salir()">{{'PAQUETES.INFOPAQ.BOTONES.BACK' | translate}}</button>
    </div>

  </ng-container>

  <ng-container *ngIf="productoMultiple">
    <h2 class="mt-20">{{'CONSULTATABLA.PRODUCTOS.'+selectSector | translate}}</h2>

    <mat-divider class="mb-20"></mat-divider>

    <div class="" fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20" fxFlex="80">
        <mat-icon class="s-30 mr-20">info</mat-icon>
        <div class="h3 secondary-text"><b>{{'PAQUETES.INFOPAQ.CERTIFICAR.TITULO.4' | translate}}</b></div>
      </div>
      <div class="" fxLayout="row">
        <button mat-raised-button color="accent" class="mb-20" (click)="nuevoProductoMultiple()">
          <mat-icon class="mr-20">add_circle</mat-icon>
          {{'PAQUETES.INFOPAQ.BOTONES.ADDONE' | translate}}
        </button>
      </div>
    </div>

    <table mat-table [dataSource]="listaProductosMultiples" class="mat-elevation-z8">
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef style="width:80%;"> {{'PAQUETES.INFOPAQ.CERTIFICAR.INFO.TABLA.1' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{'CONSULTATABLA.PRODUCTOS.'+element.clave | translate}} </td>
      </ng-container>
      <ng-container matColumnDef="ops">
        <th mat-header-cell *matHeaderCellDef> {{'PAQUETES.INFOPAQ.CERTIFICAR.INFO.TABLA.2' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <button mat-raised-button color="primary" (click)="detalleProductoMultiple(element)">{{'PAQUETES.INFOPAQ.BOTONES.DETAIL' | translate}}</button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnasProdMult"></tr>
      <tr mat-row *matRowDef="let row; columns: columnasProdMult;"></tr>
    </table>

    <mat-divider class="mt-20 mb-20"></mat-divider>

    <div fxLayout="row" fxLayoutAlign="space-evenly center">
      <button mat-raised-button color="accent" class="mt-20" (click)="cierraListaMultiple()">{{'PAQUETES.INFOPAQ.BOTONES.BACK' | translate}}</button>
    </div>

  </ng-container>

  <ng-container *ngIf="data.formulario == 'producto' || operacionInterna && !productoMultiple">

    <!-- <h2>No ha configurado este producto</h2> -->

    <div class="statusDiv" fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch"  [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
      <div *ngIf="!productoConfigurado; else tagSinProd" class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
        <h2>{{'PAQUETES.INFOPAQ.CERTIFICAR.TITULO.1' | translate}}</h2>
        <mat-icon class="ml-20 s-40">error_outline</mat-icon>
      </div>
      <ng-template #tagSinProd>
        <div class="roundEdg done mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
          <h2>{{'PAQUETES.INFOPAQ.CERTIFICAR.TITULO.2' | translate}}</h2>
          <mat-icon class="ml-20 s-40">check_circle</mat-icon>
        </div>
      </ng-template>
    </div>

    <mat-divider class="mt-20 mb-20"></mat-divider>


    <ng-container *ngIf="productoConfigurado; else formConfigProd">

      <div class="" fxLayout="row" fxLayoutAlign="start">
        <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="50">
          <h3>{{'PAQUETES.INFOPAQ.CERTIFICAR.INFO.TITULO' | translate}}</h3>
          <mat-divider class="mb-20"></mat-divider>
          <div class="h4 secondary-text">{{'PAQUETES.INFOPAQ.CERTIFICAR.INFO.TIPO' | translate}}</div>
          <h4 class="mt-0 ml-5">{{'CONSULTATABLA.PRODUCTOS.'+datosProductoConfigurado.claveProducto | translate}}</h4>
          <div class="h4 secondary-text">{{'PAQUETES.INFOPAQ.CERTIFICAR.INFO.TEMP' | translate}}</div>
          <h4 class="mt-0 ml-5">{{'CONSULTARENCUESTA.CATALOGOSPRODUCTOS.'+datosProductoConfigurado.idPlantilla+'.NOMBRE' | translate}}</h4>
          <div class="h4 secondary-text">{{'PAQUETES.INFOPAQ.CERTIFICAR.INFO.STATUS.TITULO' | translate}}</div>
          <h4 class="mt-0 ml-5">{{'PAQUETES.INFOPAQ.CERTIFICAR.INFO.STATUS.1' | translate}}</h4>
          <!-- <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
            <mat-icon class="s-30 mr-20">filter_1</mat-icon>
          </div> -->
        </div>
        <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="50">
          <h3>{{'PAQUETES.INFOPAQ.CERTIFICAR.INFO.SECCIONES' | translate}}</h3>
          <mat-divider class="mb-20"></mat-divider>
          <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event,datosProductoConfigurado.secciones,datosProductoConfigurado.fechaCertificar)">
            <ng-container *ngFor="let seccion of datosProductoConfigurado.secciones">
              <div class="example-box" *ngIf="seccion.visible == 1" cdkDrag >
                <mat-icon aria-hidden="false" class="mr-20" matTooltip="" cdkDragHandle>menu</mat-icon>
                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                <div appearance="outline" fxFlex="50" class="pr-4" fxLayoutAlign="start center">
                  <mat-checkbox [(ngModel)]="seccion.estatus" (change)="updateStatus($event,seccion._id,datosProductoConfigurado.fechaCertificar)">
                    {{'CONSULTATABLA.'+seccion.nombre | translate}}
                  </mat-checkbox>
                </div>
              </div>
            </ng-container>
          </div>

        </div>
      </div>

    </ng-container>

    <ng-template #formConfigProd>
      <h3>{{'PAQUETES.INFOPAQ.CERTIFICAR.INSTRUC' | translate}}</h3>
      <div fxLayout="column" fxLayoutAlign="start stretch">

        <mat-form-field appearance="outline" *ngIf="!operacionInterna">
          <mat-label>{{'PAQUETES.INFOPAQ.CERTIFICAR.TIPO' | translate}}</mat-label>
          <mat-select [(value)]="selectSector" >
            <mat-option *ngFor="let producto of listaProductosElegidos" [value]="producto.idProducto" (click)="getEmail_Plantillas(producto.idProducto);">
              {{'CONSULTATABLA.PRODUCTOS.'+producto.idProducto | translate}}
            </mat-option>
          </mat-select>
          <mat-error></mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="data.numProducto != 3">
          <mat-label>{{'CONSULTATABLA.SELECT_PLANTILLA' | translate}}</mat-label>
          <mat-select [(value)]='selectPlantilla'>
            <mat-option *ngFor="let plantilla of plantillas_lan" [value]="plantilla">
              {{plantilla.nombrePlantilla}}
            </mat-option>
          </mat-select>
          <mat-error></mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="data.numProducto != 3">
          <mat-label>{{'CONSULTATABLA.SELECT_EMAIL_PLANTILLA' | translate}}</mat-label>
          <mat-select [(value)]='selectPlantillaEmail'>
            <mat-option *ngFor="let plantilla_email of plantillas_email" [value]="plantilla_email.paqueteId">
              {{plantilla_email.nombrePaquete}}
            </mat-option>
          </mat-select>
          <mat-error></mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="data.numProducto != 3">
          <mat-label>{{'CONSULTATABLA.SELECT_CSSID2' | translate}}</mat-label>
          <mat-select [(value)]='selectEstilo'>
            <mat-option *ngFor="let estilo of estilos" [value]="estilo.cssId">
              {{'CONSULTATABLA.'+estilo.cssId | translate}}
            </mat-option>
          </mat-select>
          <mat-error></mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="data.numProducto == 3 && selectSector != 22">
          <mat-label>{{'CONSULTATABLA.SURVEYTK_TITU' | translate}}</mat-label>
          <input matInput [(ngModel)]='surveyToken' placeholder="{{'CONSULTATABLA.SURVEYTK_DESC' | translate}}">
          <mat-error></mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="data.numProducto == 3">
          <mat-label>link</mat-label>
          <input matInput [(ngModel)]='linkRes' placeholder="enlase">
          <mat-error></mat-error>
        </mat-form-field>

      </div>

    </ng-template>



    <mat-divider class="mt-20 mb-20"></mat-divider>

    <div fxLayout="row" fxLayoutAlign="space-evenly center">
      <button *ngIf="data.formulario == 'producto' && !productoConfigurado" mat-raised-button color="accent" class="mt-20" (click)="salir()">{{'PAQUETES.INFOPAQ.BOTONES.CANCELAR' | translate}}</button>
      <button *ngIf="data.formulario == 'producto' && productoConfigurado" mat-raised-button color="accent" class="mt-20" (click)="salir()">{{'PAQUETES.INFOPAQ.BOTONES.BACK' | translate}}</button>
      <button *ngIf="data.formulario == 'categoria' && operacionInterna" mat-raised-button color="accent" class="mt-20" (click)="opInterna()">{{'PAQUETES.INFOPAQ.BOTONES.BACK' | translate}}</button>
      <button *ngIf="!productoConfigurado" mat-raised-button color="primary" class="mt-20" (click)="registerProduct()">{{'PAQUETES.INFOPAQ.BOTONES.ADD' | translate}}</button>
    </div>

  </ng-container>


</div>
